import type { NavigationGuard, RouteLocationNormalizedGeneric } from 'vue-router'
import { useToken } from '@/shared/composables/useToken'
import { isRedirectPackages, isShortLink } from '@/business-rules'
import { EMcweb, EPage } from '@/shared/enum/page.enum'
import { useAppStore } from '@/stores/app'
import isRedirectCampaigns from '@/shared/utils/is-redirect-campaigns'
import { EChannel } from '@/shared/enum/channel.enum'
import { PROMOTIONS } from '@/shared/constants/common.constants'
import { ECountry } from '@/shared/enum/country.enum'
import isSkipHome from '@/shared/utils/is-skip-home'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'

const keepParams = (to: RouteLocationNormalizedGeneric) => {
  const { query } = to
  if (Object.prototype.hasOwnProperty.call(query, 't')) {
    delete query.t
  }
  return query
}

export const rootPathGuard: NavigationGuard = async (to, _from, next) => {
  const query = keepParams(to)

  const appStore = useAppStore()
  const { campaign, isProfiledToken, app, msisdn, isMCAPP } = useToken()
  const hasMsisdn = msisdn.value !== ''

  if (app.value === EChannel.MCWEB) {
    return next({ name: EMcweb.MCW })
  }

  // TODO: MANDAR ESTA LOGICA A UN COMPOSABLE
  if (PROMOTIONS.includes(campaign.value.toUpperCase()) && appStore.country === ECountry.SV) {
    return next({ name: EPage.PROMOTIONS, params: { promotion: campaign.value } })
  }

  if (hasMsisdn && isShortLink(campaign.value)) {
    return next({ name: EPage.SHORT_LINK, query })
  }

  if (isShortLink(campaign.value) || isRedirectPackages(campaign.value, appStore.country)) {
    return next({ name: EPage.BUY_RECHARGES, query })
  }

  if (
    (isMCAPP.value || isRedirectPackages(campaign.value, appStore.country)) &&
    isProfiledToken.value
  ) {
    return next({ name: EPage.PACKAGES })
  }

  if (isMCAPP.value || isRedirectCampaigns(campaign.value)) {
    return next({ name: EPage.SEND_RECHARGES, query })
  }

  if (!isSkipHome()) {
    return next({ name: EPage.LANDING, query })
  }
  localStorage.removeItem(ELocalStorageKey.SKIP_HOME)

  if (hasMsisdn) {
    return next({ name: EPage.PACKAGES })
  }

  return next({ name: EPage.BUY_RECHARGES, query })
}
